import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getFacilityDisplayName } from '../data/sponsors';

type ServiceKey =
  | 'weddings'
  | 'reunions'
  | 'parties'
  | 'sporting'
  | 'practices'
  | 'fitness'
  | 'track';

const Services: React.FC = () => {
  const navigate = useNavigate();
  const walkingTrackName = getFacilityDisplayName('walking-track');

  const handleServiceClick = (key: ServiceKey) => {
    switch (key) {
      case 'weddings':
        navigate('/services/weddings');
        break;
      case 'reunions':
        navigate('/services/reunions');
        break;
      case 'parties':
        navigate('/services/parties');
        break;
      case 'sporting':
        navigate('/services/sporting-events');
        break;
      case 'practices':
        navigate('/services/sport-practices');
        break;
      case 'fitness':
        navigate('/services/fitness-area');
        break;
      case 'track':
        navigate('/services/walking-track');
        break;
      default:
        break;
    }
  };

  const serviceOptions: { key: ServiceKey; label: string }[] = [
    { key: 'weddings', label: 'Weddings' },
    { key: 'reunions', label: 'Reunions' },
    { key: 'parties', label: 'Parties' },
    { key: 'sporting', label: 'Sporting Events' },
    { key: 'practices', label: 'Sport Practices' },
    { key: 'fitness', label: 'Fitness Area' },
    { key: 'track', label: walkingTrackName }
  ];

  return (
    <div className="services-section">
      <div className="services-container">
        <h2 className="services-title">Our Services</h2>
        <p className="services-subtitle">
          TDS Event Center offers versatile spaces for weddings, celebrations, sports, and fitness activities.
        </p>
        <div className="services-dropdown">
          <select
            id="servicesSelect"
            aria-label="Services"
            defaultValue=""
            onChange={(event) => {
              const value = event.target.value as ServiceKey;
              if (value) {
                handleServiceClick(value);
              }
              event.currentTarget.value = '';
            }}
          >
            <option value="" disabled>
              Select a service
            </option>
            {serviceOptions.map((option) => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className="services-grid">
          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('weddings')}
          >
            <div className="service-icon">💒</div>
            <h3>Weddings</h3>
            <p>Elegant spaces and amenities for your special day.</p>
            <span className="service-card-cta">View details</span>
          </button>

          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('reunions')}
          >
            <div className="service-icon">👨‍👩‍👧‍👦</div>
            <h3>Reunions</h3>
            <p>Perfect venues for family and class reunions.</p>
            <span className="service-card-cta">View details</span>
          </button>

          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('parties')}
          >
            <div className="service-icon">🎉</div>
            <h3>Parties</h3>
            <p>Celebrate in style with our flexible event spaces.</p>
            <span className="service-card-cta">View details</span>
          </button>

          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('sporting')}
          >
            <div className="service-icon">🏆</div>
            <h3>Sporting Events</h3>
            <p>Host tournaments and competitions in our facilities.</p>
            <span className="service-card-cta">View details</span>
          </button>

          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('practices')}
          >
            <div className="service-icon">⚽</div>
            <h3>Sport Practices</h3>
            <p>Regular practice sessions and training opportunities.</p>
            <span className="service-card-cta">View details</span>
          </button>

          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('fitness')}
          >
            <div className="service-icon">💪</div>
            <h3>Fitness Area</h3>
            <p>Fitness facilities for members.</p>
            <span className="service-card-cta">View details</span>
          </button>

          <button
            type="button"
            className="service-card service-card-clickable"
            onClick={() => handleServiceClick('track')}
          >
            <div className="service-icon">🚶</div>
            <h3>{walkingTrackName}</h3>
            <p>Indoor walking track for all fitness levels.</p>
            <span className="service-card-cta">View details</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Services;